import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { VendorsController } from './vendors.controller';
import { VendorsService } from './vendors.service';
import {VendorsAdapter} from './dto/vendors.adapter';
import { Vendors } from './vendors.entity'
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([Vendors]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [VendorsController],
  providers: [VendorsService,VendorsAdapter,ApplicationExceptionHandler,LogsService],
  exports: [VendorsService],
})
export class VendorsModule {}
